import React from "react";

import cn from "classnames";

import styles from "./PageContainer.module.scss";

interface Props {
  children: React.ReactNode;
  footer?: React.ReactNode;
  headerContent?: React.ReactNode;
  subTitle?: React.ReactNode;
  title?: string;
}

const PageContainer: React.FC<Props> = ({ children, footer, headerContent, subTitle, title }) => (
  <section className={styles.container}>
    <section className={styles.contentContainer}>
      <div className={cn(styles.content, styles.fixedWidth)}>
        {title || subTitle ? (
          <header className={styles.headerContainer}>
            <div>
              <div className={styles.title}>{title}</div>
              {subTitle && <div className={styles.subTitle}>{subTitle}</div>}
            </div>
            {headerContent && <div>{headerContent}</div>}
          </header>
        ) : null}
        {children}
      </div>
    </section>
    <footer className={styles.footerContainer}>
      <div className={cn(styles.footer, styles.fixedWidth)}>{footer}</div>
    </footer>
  </section>
);

export default PageContainer;
